export default __webpack_public_path__ + "71509c349da645339ee4814d04768a2c.woff2";